import {
  Avatar,
  Box,
  Container,
  Grid,
  Paper,
  TableSortLabel,
  Typography,
} from "@mui/material";
import React, { useRef, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { visuallyHidden } from "@mui/utils";
import { baseUrl } from "../../services/AzureStorage";
import { useNavigate } from "react-router-dom";
import RouteConstants from "../../common/RouteConstants";
import Helper from "../../common/Helper";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import DashboardCard from "../home/DashboardCard";

export default function CombineResultsSAA(props) {
  let navigate = useNavigate();
  const useStyles = makeStyles((theme) => ({
    root: {
      margin: "5px 15px",
      border: "1px solid lightgrey",
      borderRadius: "10px",
      boxShadow: "2px 2px 11px grey inset",
    },
    listItemIcon: {
      minWidth: "38px",
    },
    imageIcon: {
      width: "100%",
      height: "100%",
      cursor: "pointer",
    },
    iconRoot: {
      textAlign: "center",
      width: "100%",
      height: "50px",
    },
    cardStyle: {
      border: "1px solid lightgrey",
      borderRadius: "10px",
      height: "250px",
    },
    headerText: {
      marginBottom: theme.spacing(0.5),
      color: "rgb(29, 66, 138)",
    },
    headerText2: {
      marginBottom: theme.spacing(0.5),
      color: "rgb(29, 66, 138)",
    },
    headerTextInfo: {
      color: "rgb(29, 66, 138)",
      fontSize: "14px",
    },
    headerBox: {
      background: "#c1d0ed",
      borderRadius: "17px",
    },
    smBlue: {
      marginLeft: "16px",
      width: 26,
      height: 26,
      color: theme.palette.getContrastText("#0c2c75"),
      backgroundColor: "#1e3f7e",
      position: "relative",
      borderRadius: "50%",
    },
    stickyColumn: {
      position: "sticky",
      background: "white",
      left: 0,
      zIndex: 1,
      paddingRight: theme.spacing(1),
    },
    playerNameStyle: {
      fontSize: "12px",
      cursor: "pointer",
      "&:hover": {
        color: "blue",
      },
    },
    cellValue: {
      padding: "4px",
      fontSize: "12px",
    },
  }));
  const classes = useStyles();
  const {
    favPlayersASAData,
    favPlayersASADataselected,
    playerAnthrosAndStrengthAgiltyColumns,
    Showval,
    notes,
    loading,
    laneShuttleLeft,
    laneShuttleRight,
    threeFour,
    proLane,
    maxVerticalJump,
    standingVerticalJump,
    eventId,
    lengthUnits,
    getHandDimensionsUnitValue,
    getHandDimensionsUnitLabelType,
    selectedTab,
    isWebView,
  } = props;

  const [order, setOrder] = React.useState("asc");

  const [orderBy, setOrderBy] = React.useState("playerName");

  const tab2Ref = useRef();

  useEffect(() => {
    if (selectedTab === 1) {
      tab2Ref.current.addEventListener("touchstart", isolateTouch, {
        passive: true,
      });
      tab2Ref.current.addEventListener("touchmove", isolateTouch, {
        passive: true,
      });
      tab2Ref.current.addEventListener("touchend", isolateTouch, {
        passive: true,
      });
    }

    return () => {
      if (tab2Ref.current) {
        tab2Ref.current.removeEventListener("touchstart", isolateTouch, {
          passive: true,
        });
        tab2Ref.current.removeEventListener("touchmove", isolateTouch, {
          passive: true,
        });
        tab2Ref.current.removeEventListener("touchend", isolateTouch, {
          passive: true,
        });
      }
    };
  }, [selectedTab]);

  const isolateTouch = (e) => {
    e.stopPropagation();
  };

  const handleSortRequest = (e, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  function getComparator(sortOrder, sortOrderBy) {
    return (a, b) => {
      return compareGeneric(a, b, sortOrder, sortOrderBy);
    };
  }

  function compareGeneric(a, b, sortOrder, sortOrderBy) {
    const getValue = (obj) => {
      const value = obj[sortOrderBy];
      if (value === null || value === undefined || value === "") {
        return "";
      }
      //return !isNaN(parseFloat(value)) ? parseFloat(value) : String(value);
      return /^[+-]?(\d+(\.\d*)?|\.\d+)$/.test(String(value).trim())
        ? parseFloat(value)
        : String(value);
    };

    const valueA = getValue(a);
    const valueB = getValue(b);

    if (valueA === valueB) {
      return 0;
    } else {
      if (typeof valueA === "string") {
        return sortOrder === "asc"
          ? valueA.localeCompare(valueB)
          : valueB.localeCompare(valueA);
      } else {
        return sortOrder === "asc" ? valueA - valueB : valueB - valueA;
      }
    }
  }

  const viewPlayerProfile = (playerId, playerName) => {
    if (isWebView) {
      return sendNavigation("PLAYER_DETAILS", { UserName: playerName });
    }

    navigate(`/${eventId}${RouteConstants.VIEW_PLAYER_PROFILE}/${playerId}`, {
      state: { from: "CombineResults", tab: 1 },
    });
  };

  const sendNavigation = (screenName, params) => {
    window.ReactNativeWebView?.postMessage(
      JSON.stringify({ action: "NAVIGATE", screen: screenName, params })
    );
  };

  var newplayerAnthrosAndStrengthAgiltyColumns = [];

  playerAnthrosAndStrengthAgiltyColumns &&
    playerAnthrosAndStrengthAgiltyColumns.map((val, index) => {
      if (
        val.id === "playerName" ||
        // val.id === "position" ||
        // val.id === "collegeOrClub" ||
        val.id === "shuttleRunLeftTrialTime" ||
        val.id === "shuttleRunRightTrialTime" ||
        val.id === "threeFourRunTime" ||
        val.id === "proLaneTrialTime" ||
        val.id === "maxVerticalLeap" ||
        val.id === "standingVerticalLeap"
      ) {
        newplayerAnthrosAndStrengthAgiltyColumns.push({
          id: val.id,
          headerName: val.headerName,
        });
      }
    });
  return (
    <Container maxWidth={false}>
      <Box mt={2} mb={2}>
        <Paper elevation={2} sx={{ p: 2 }}>
          <Box
            display="flex"
            alignItems="center"
            flexDirection="row"
            className={classes.headerBox}
          >
            <Box display="flex" pl={2}>
              <Typography className={`${classes.headerText} headerTitle`}>
                Strength And Agility
              </Typography>
            </Box>
          </Box>
          <Grid container spacing={2} pt={3}>
            <TableContainer ref={tab2Ref}>
              {favPlayersASAData && favPlayersASAData.length > 0 && (
                <Table>
                  <TableHead>
                    {newplayerAnthrosAndStrengthAgiltyColumns.map((elem, i) => {
                      return (
                        <TableCell
                          className={
                            elem.id === "playerName"
                              ? classes.stickyColumn
                              : classes.na
                          }
                          sx={{
                            padding: "4px",
                            paddingLeft:
                              elem.id === "playerName" ? "25px" : "0px",
                            fontSize: "12px",
                          }}
                        >
                          <TableSortLabel
                            active={orderBy === elem.id}
                            direction={orderBy === elem.id ? order : "asc"}
                            onClick={(e) => handleSortRequest(e, elem.id)}
                          >
                            {elem.headerName}
                            {orderBy === elem.id ? (
                              <Box component="span" sx={visuallyHidden}>
                                {order === "desc"
                                  ? "sorted descending"
                                  : "sorted ascending"}
                              </Box>
                            ) : null}
                          </TableSortLabel>
                        </TableCell>
                      );
                    })}
                  </TableHead>
                  <TableHead>
                    <TableCell className={classes.stickyColumn}></TableCell>
                    {/* <TableCell></TableCell>
                    <TableCell></TableCell> */}
                    <TableCell>(sec)</TableCell>
                    <TableCell>(sec)</TableCell>
                    <TableCell>(sec)</TableCell>
                    <TableCell>(sec)</TableCell>
                    <TableCell>
                      {getHandDimensionsUnitLabelType(lengthUnits)}
                    </TableCell>
                    <TableCell>
                      {getHandDimensionsUnitLabelType(lengthUnits)}
                    </TableCell>
                  </TableHead>
                  <TableBody className="scrollTable">
                    {Showval
                      ? favPlayersASADataselected
                          .slice()
                          .sort(getComparator(order, orderBy))
                          .map((val, index) => {
                            return (
                              <TableRow className="scrollTable">
                                <TableCell
                                  className={classes.stickyColumn}
                                  sx={{ padding: "5px", fontSize: "12px" }}
                                >
                                  <Box display="flex">
                                    {val.headshotURL &&
                                    val.headshotURL !== "" ? (
                                      <Avatar
                                        className={classes.smBlue}
                                        sx={{
                                          bgcolor: "#1d428a",
                                          cursor: "pointer",
                                        }}
                                        src={
                                          val.headshotURL
                                            ? baseUrl(val.headshotURL)
                                            : ""
                                        }
                                        alt="basketball"
                                        title="View Player Profile"
                                        onClick={() =>
                                          viewPlayerProfile(
                                            val.playerID,
                                            val.playerName
                                          )
                                        }
                                      >
                                        <Typography variant="caption">
                                          {Helper.GetNameInitials(
                                            `${val.playerName}`
                                          )}
                                        </Typography>
                                      </Avatar>
                                    ) : (
                                      <Avatar
                                        className={classes.smBlue}
                                        sx={{
                                          bgcolor: "#1d428a",
                                          cursor: "pointer",
                                        }}
                                        alt="basketball"
                                        title="View Player Profile"
                                        onClick={() =>
                                          viewPlayerProfile(
                                            val.playerID,
                                            val.playerName
                                          )
                                        }
                                      >
                                        <Typography variant="caption">
                                          {Helper.GetNameInitials(
                                            `${val.playerName}`
                                          )}
                                        </Typography>
                                      </Avatar>
                                    )}
                                    &nbsp;&nbsp;
                                    <Typography
                                      variant="body2"
                                      className={classes.playerNameStyle}
                                      title="View Player Profile"
                                      onClick={() =>
                                        viewPlayerProfile(
                                          val.playerID,
                                          val.playerName
                                        )
                                      }
                                    >
                                      {`${val.playerName}  ${
                                        val.trevisoText || ""
                                      }`}
                                    </Typography>
                                  </Box>
                                </TableCell>
                                {/* <TableCell className={classes.cellValue}>
                                  <Box display="flex">
                                    {val.position ? val.position : "-"}
                                  </Box>
                                </TableCell>
                                <TableCell className={classes.cellValue}>
                                  <Box display="flex">
                                    {val.collegeOrClub
                                      ? val.collegeOrClub
                                      : "-"}
                                  </Box>
                                </TableCell> */}
                                <TableCell className={classes.cellValue}>
                                  <Box display="flex">
                                    {val.shuttleRunLeftTrialTime
                                      ? val.shuttleRunLeftTrialTime
                                      : "-"}
                                  </Box>
                                </TableCell>
                                <TableCell className={classes.cellValue}>
                                  <Box display="flex">
                                    {val.shuttleRunRightTrialTime
                                      ? val.shuttleRunRightTrialTime
                                      : "-"}
                                  </Box>
                                </TableCell>
                                <TableCell className={classes.cellValue}>
                                  <Box display="flex">
                                    {val.threeFourRunTime
                                      ? val.threeFourRunTime
                                      : "-"}
                                  </Box>
                                </TableCell>
                                <TableCell className={classes.cellValue}>
                                  <Box display="flex">
                                    {val.proLaneTrialTime
                                      ? val.proLaneTrialTime
                                      : "-"}
                                  </Box>
                                </TableCell>
                                <TableCell className={classes.cellValue}>
                                  <Box display="flex">
                                    {getHandDimensionsUnitValue(
                                      val.maxVerticalLeap
                                    )}
                                  </Box>
                                </TableCell>
                                <TableCell className={classes.cellValue}>
                                  <Box display="flex">
                                    {/* {val.standingVerticalFeet}'{" "}
                                  {val.standingVerticalInches}" */}
                                    {getHandDimensionsUnitValue(
                                      val.standingVerticalLeap
                                    )}
                                  </Box>
                                </TableCell>
                              </TableRow>
                            );
                          })
                      : favPlayersASAData
                          .slice()
                          .sort(getComparator(order, orderBy))
                          .map((val, index) => {
                            return (
                              <TableRow className="scrollTable">
                                <TableCell
                                  className={classes.stickyColumn}
                                  sx={{ padding: "4px", fontSize: "12px" }}
                                >
                                  <Box display="flex">
                                    {val.headshotURL &&
                                    val.headshotURL !== "" ? (
                                      <Avatar
                                        className={classes.smBlue}
                                        sx={{
                                          bgcolor: "#1d428a",
                                          cursor: "pointer",
                                        }}
                                        src={
                                          val.headshotURL
                                            ? baseUrl(val.headshotURL)
                                            : ""
                                        }
                                        alt="basketball"
                                        title="View Player Profile"
                                        onClick={() =>
                                          viewPlayerProfile(
                                            val.playerID,
                                            val.playerName
                                          )
                                        }
                                      >
                                        <Typography variant="caption">
                                          {Helper.GetNameInitials(
                                            `${val.playerName}`
                                          )}
                                        </Typography>
                                      </Avatar>
                                    ) : (
                                      <Avatar
                                        className={classes.smBlue}
                                        sx={{
                                          bgcolor: "#1d428a",
                                          cursor: "pointer",
                                        }}
                                        alt="basketball"
                                        title="View Player Profile"
                                        onClick={() =>
                                          viewPlayerProfile(
                                            val.playerID,
                                            val.playerName
                                          )
                                        }
                                      >
                                        <Typography
                                          variant="caption"
                                          sx={{ fontSize: "12px" }}
                                        >
                                          {Helper.GetNameInitials(
                                            `${val.playerName}`
                                          )}
                                        </Typography>
                                      </Avatar>
                                    )}
                                    &nbsp;&nbsp;
                                    <Typography
                                      variant="body2"
                                      className={classes.playerNameStyle}
                                      title="View Player Profile"
                                      onClick={() =>
                                        viewPlayerProfile(
                                          val.playerID,
                                          val.playerName
                                        )
                                      }
                                    >
                                      {`${val.playerName}  ${
                                        val.trevisoText || ""
                                      }`}
                                    </Typography>
                                  </Box>
                                </TableCell>
                                {/* <TableCell className={classes.cellValue}>
                                  <Box display="flex">
                                    {val.position ? val.position : "-"}
                                  </Box>
                                </TableCell>
                                <TableCell className={classes.cellValue}>
                                  <Box display="flex">
                                    {val.collegeOrClub
                                      ? val.collegeOrClub
                                      : "-"}
                                  </Box>
                                </TableCell> */}
                                <TableCell className={classes.cellValue}>
                                  <Box display="flex">
                                    {val.shuttleRunLeftTrialTime
                                      ? val.shuttleRunLeftTrialTime
                                      : "-"}
                                  </Box>
                                </TableCell>
                                <TableCell className={classes.cellValue}>
                                  <Box display="flex">
                                    {val.shuttleRunRightTrialTime
                                      ? val.shuttleRunRightTrialTime
                                      : "-"}
                                  </Box>
                                </TableCell>
                                <TableCell className={classes.cellValue}>
                                  <Box display="flex">
                                    {val.threeFourRunTime
                                      ? val.threeFourRunTime
                                      : "-"}
                                  </Box>
                                </TableCell>
                                <TableCell className={classes.cellValue}>
                                  <Box display="flex">
                                    {val.proLaneTrialTime
                                      ? val.proLaneTrialTime
                                      : "-"}
                                  </Box>
                                </TableCell>
                                <TableCell className={classes.cellValue}>
                                  <Box display="flex">
                                    {/* {val.maxVerticalFeet}' {val.maxVerticalInches}
                                  " */}
                                    {getHandDimensionsUnitValue(
                                      val.maxVerticalLeap
                                    )}
                                  </Box>
                                </TableCell>
                                <TableCell className={classes.cellValue}>
                                  <Box display="flex">
                                    {/* {val.standingVerticalFeet}'{" "}
                                  {val.standingVerticalInches}" */}
                                    {getHandDimensionsUnitValue(
                                      val.standingVerticalLeap
                                    )}
                                  </Box>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                  </TableBody>
                </Table>
              )}
            </TableContainer>
          </Grid>
        </Paper>
      </Box>
      <Box mt={2} mb={2}>
        <Paper elevation={2} sx={{ p: 2 }}>
          <Box
            display="flex"
            alignItems="center"
            flexDirection="row"
            className={classes.headerBox}
          >
            <Box display="flex" pl={2}>
              <Typography className={`${classes.headerText} headerTitle`}>
                Strength And Agility
              </Typography>
            </Box>
            <Box display="flex" pl={2}>
              {notes &&
                notes.length > 0 &&
                notes.find(
                  (x) =>
                    x.childName.replace(/\s/g, "").toLowerCase() ===
                    "StrengthAndAgility".toLocaleLowerCase()
                ).isActive && (
                  <>
                    {/* <InfoOutlinedIcon style={{ color: "#fff" }} /> */}
                    <Typography
                      // className="subtitle2"
                      className={classes.headerTextInfo}
                    >
                      {
                        notes.find(
                          (x) =>
                            x.childName.replace(/\s/g, "").toLowerCase() ===
                            "StrengthAndAgility".toLocaleLowerCase()
                        ).description
                      }
                    </Typography>
                  </>
                )}
            </Box>
          </Box>

          {loading && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress />
            </Box>
          )}

          {/* <Loader isLoading={loading} /> */}
          <Grid container spacing={2} pt={2}>
            <DashboardCard
              title="Lane Shuttle Left(s)"
              data={laneShuttleLeft}
              value="2010"
              unit="(sec)"
              from="CombineResults"
              tab={1}
              eventId={eventId}
              isWebView={isWebView}
            />

            <DashboardCard
              title="Lane Shuttle Right(s)"
              data={laneShuttleRight}
              value="2011"
              unit="(sec)"
              from="CombineResults"
              tab={1}
              eventId={eventId}
              isWebView={isWebView}
            />

            <DashboardCard
              title="3/4 Court Sprint (s)"
              data={threeFour}
              value="202"
              unit="(sec)"
              from="CombineResults"
              tab={1}
              eventId={eventId}
              isWebView={isWebView}
            />

            <DashboardCard
              title="Pro Lane(s)"
              unit="(sec)"
              data={proLane}
              value="203"
              from="CombineResults"
              tab={1}
              eventId={eventId}
              isWebView={isWebView}
            />

            <DashboardCard
              title="Max Vertical Jump"
              data={maxVerticalJump}
              unit={getHandDimensionsUnitLabelType(lengthUnits)}
              value="204"
              from="CombineResults"
              tab={1}
              eventId={eventId}
              getHandDimensionsUnitValue={getHandDimensionsUnitValue}
              isWebView={isWebView}
            />

            <DashboardCard
              title="Standing Vertical"
              data={standingVerticalJump}
              unit={getHandDimensionsUnitLabelType(lengthUnits)}
              value="205"
              from="CombineResults"
              tab={1}
              eventId={eventId}
              getHandDimensionsUnitValue={getHandDimensionsUnitValue}
              isWebView={isWebView}
            />
          </Grid>
        </Paper>
      </Box>
    </Container>
  );
}
